import RefappHotspots from './components/refapp-hotspots.vue';
import RefappHotspotsProvider from './components/provider.vue';

export default {
  install(app) {
    const components = [RefappHotspots, RefappHotspotsProvider];
    components.forEach((c) => app.component(c.name, c));
  },
};
